
import { Component, ViewChild, ElementRef } from "@angular/core";
import { TranslocoService } from "@jsverse/transloco";
import { ModalComponent } from "remarketing-ui-components-lib";
import { takeUntil } from "rxjs";
import { AnalyticsService, SaComponent } from "smartauction-frontend-micro-library";

@Component({
    selector: 'app-seller-disclosure-modal',
    templateUrl: './seller-disclosure-modal.component.html',
    styleUrls: ['./seller-disclosure-modal.component.scss'],
    imports: [ModalComponent]
})

export class SellerDisclosureModalComponent extends SaComponent {
  @ViewChild(ModalComponent) modal: ModalComponent;
  @ViewChild('sellerDisclosureBody4') sellerDisclosureBody4: ElementRef;
  modalId = 'Seller-Disclosure-Modal';

  translations = {
    modalClose: '',
    sellerDisclosureHeader: '',
    sellerDisclosureModal: '',
    sellerDisclosureBody1: '',
    sellerDisclosureBody2: '',
    sellerDisclosureBody3: ''
  }

  constructor(
    private readonly translocoService: TranslocoService,
    private readonly analyticsService: AnalyticsService
  ) {
    super();
  }

  show(): void {
    this.getTranslations();
    this.modal.show();
    setTimeout(() => {
      this.analyticsService.track('modalView','Seller Disclosures')
    }, 0)
  }

  close() {
    this.modal.close();
  }

  getTranslations() {
    const keyParams = {
      'common': {},
      'sellModule.posting.conditionForm': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translate => {
        this.translations.modalClose = translate[0].modalClose;
        this.translations.sellerDisclosureHeader = translate[1].sellerDisclosureHeader;
        this.translations.sellerDisclosureModal = translate[1].sellerDisclosureModal;
        this.translations.sellerDisclosureBody1 = translate[1].sellerDisclosureBody1;
        this.translations.sellerDisclosureBody2 = translate[1].sellerDisclosureBody2;
        this.translations.sellerDisclosureBody3 = translate[1].sellerDisclosureBody3;
        this.sellerDisclosureBody4.nativeElement.innerHTML = translate[1].sellerDisclosureBody4;
      });
  }
}
